import * as React from 'react';
import clx from 'classnames';
import { Typography, Table, Divider } from 'antd';
const { Title, Text } = Typography;
import './DossierListTable.scss';
import { TableProps } from 'antd/lib/table';

export interface DossierListTableProps extends Omit<TableProps<any>, 'title'> {
  title: string;
}

/**
 * Tabella per la visualizzazione dell'elenco
 * dei Fascicolo o Documenti del Documentale
 */
export function DossierListTable(props: DossierListTableProps) {
  const { title, className, ...othersProps } = props;

  return (
    <>
      <Text
        strong
        style={{
          marginBottom: '12px',
          marginTop: '24px',
          display: 'block'
        }}
      >
        {title}
      </Text>
      <Divider style={{ margin: 0 }} />
      <Table
        className={clx('document-list-table', className)}
        tableLayout="fixed"
        showHeader={false}
        size="small"
        pagination={false}
        indentSize={30}
        {...othersProps}
      />
    </>
  );
}
